import React, { Component } from "react";
import { connect } from 'react-redux';
import * as actions from '../../store/actions/index'

import BuildControls from "../../components/Burger/BuildControls/BuildControls";
import Burger from "../../components/Burger/Burger";
import OrderSummary from "../../components/Burger/OrderSummary/OrderSummary";
import Modal from "../../components/UI/Modal/Modal";
import Aux from "../../hoc/Auxillary";
import axios from "../../axios-orders";
import Spinner from "../../components/UI/Spinner/Spinner";
import withErrorHandler from "../../hoc/withErrorHandler/withErrorHandler";

class BurgerBuilder extends Component {
  state = {
    loading: false,
    purchasing: false,
    error: false
  };

  componentDidMount() {
    this.props.ingredientsInitialized();
  }

  updatePurchaseState(ingredients) {
    const sum = Object.values(ingredients).reduce((x, y) => {
      return x + y;
    }, 0);
    return sum > 0;
  }

  purchaseHandler = () => {
    if (this.props.isAuth) {
      this.setState({ purchasing: true });
    } else {
      this.props.onSetAuthRedirectPath('/checkout');
      this.props.history.push('/auth');
    }
  };

  cancelPurchaseHandler = () => {
    this.setState({ purchasing: false });
  };

  continuePurchaseHandler = () => {
    this.props.onInitPurchase();
    this.props.history.push("/checkout");
  };

  render() {
    const disabledLess = {
      ...this.props.ingredients,
    };

    for (let key in disabledLess) {
      disabledLess[key] = disabledLess[key] <= 0;
    }

    const disabledMore = {
      ...this.props.ingredients,
    };

    for (let key in disabledMore) {
      disabledMore[key] = disabledMore[key] > 2;
    }

    let orderSummary;
    // let orderSummary = <Spinner />;
    let burger = this.props.error ? <h2 style={{textAlign: 'center'}}>There seems to be a problem fetching the ingredients from our server. Please try again later.</h2> : <Spinner />;

    if (this.props.ingredients) {
      burger = (
        <Aux>
          <Burger ingredients={this.props.ingredients} />
          <BuildControls
            totalPrice={this.props.price}
            ingredientAdded={this.props.ingredientAdded}
            ingredientRemoved={this.props.ingredientRemoved}
            disableLess={disabledLess}
            disableMore={disabledMore}
            disabledOrder={!this.updatePurchaseState(this.props.ingredients)}
            openModal={this.purchaseHandler}
            isAuth={this.props.isAuth}
          />
        </Aux>
      );
      orderSummary = (
        <OrderSummary
          ingredients={this.props.ingredients}
          price={this.props.price}
          purchaseCancelled={this.cancelPurchaseHandler}
          purchaseContinued={this.continuePurchaseHandler}
        />
      );
    }

    if (this.state.loading) {
      orderSummary = <Spinner />;
    }

    return (
      <Aux>
        <Modal
          show={this.state.purchasing}
          modalClosed={this.cancelPurchaseHandler}
        >
          {orderSummary}
        </Modal>
        {burger}
      </Aux>
    );
  }
}

const mapStateToProps = state => {
  return {
    ingredients: state.burgerBuilder.ingredients,
    price: state.burgerBuilder.totalPrice,
    error: state.burgerBuilder.error,
    isAuth: state.auth.token !== null
  };
}

const mapDisptachToProps = dispatch =>  {
  return {
    ingredientAdded: (ingredient)=> dispatch(actions.addIngredient(ingredient)),
    ingredientRemoved: (ingredient)=> dispatch(actions.removeIngredient(ingredient)),
    ingredientsInitialized: () => dispatch(actions.initIngredients()),
    onInitPurchase: () => dispatch(actions.purchaseInit()),
    onSetAuthRedirectPath: (path) => dispatch(actions.setAuthRedirectPath(path))
  }
}

export default connect(mapStateToProps, mapDisptachToProps)(withErrorHandler(BurgerBuilder, axios));
